<template>
  <el-dialog
    :visible.sync="visible"
    title="成品收货入库"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="80%"
    top="5vh"
    v-loading="loading"
  >
    <div class="dialog-content" style="padding-right:20px;">
      <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
      >
        <el-card>
          <div slot="header" class="card-header">
            <div>入库基础信息</div>
          </div>
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="入库时间：" prop="operateTime">
                <el-date-picker
                  v-model="dataForm.operateTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
                  placeholder="选择出入库时间"
                  size="mini"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
            <el-form-item label="收货仓库：" prop="storageId">
              <storages v-model="dataForm.storageId"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发票号：" prop="receiptCode">
                <el-input v-model="dataForm.receiptCode"  size="mini"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="物流公司：" prop="carriageMan">
                <dict v-model="dataForm.carriageMan" dictName="carriage_man" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="物流号：" prop="carriageNo">
                <el-input v-model="dataForm.carriageNo" size="mini"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注：" prop="remark">
                <el-input
                  v-model="dataForm.remark"
                  placeholder="备注"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="凭证照片：" prop="imgs">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>
        </el-card>

        <el-card style="margin-top:20px;">
          <div slot="header" class="card-header">
            <div>本次入库明细</div>
          </div>
          <el-table :data="dataForm.detailList" border style="width: 100%">
            <el-table-column
              type="index"
              width="50"
              label="行号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column label="品番号" prop="code" align="center">
            </el-table-column>
            <el-table-column label="品名" prop="name" align="center">
            </el-table-column>
            <el-table-column label="颜色" prop="color" align="center">
            </el-table-column>
            <el-table-column label="尺寸" prop="size" align="center">
            </el-table-column>
            <el-table-column label="规格" prop="attr1" align="center">
            </el-table-column>
            <el-table-column label="加工费单价" align="center">
              <template slot-scope="scope">
                {{ moneyFormat(scope.row.amount) }}
              </template>
            </el-table-column>
            <el-table-column label="检品费单价" align="center">
              <template slot-scope="scope">
                {{ moneyFormat(scope.row.checkAmount) }}
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="count" align="center">
            </el-table-column>
            <el-table-column
              label="本次数量"
              header-align="center"
              align="center"
              width="160"
            >
              <template slot-scope="scope">
                <el-form-item
                  :prop="'detailList.' + scope.$index + '.realCount'"
                  :rules="detailRule.count"
                  label-width="0"
                  style="margin-top: 20px"
                  size="mini"
                >
                  <el-input v-model="scope.row.realCount"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              width="100"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  icon="el-icon-remove"
                  type="text"
                  @click="delRow(scope.$index, scope.row, 'detailList')"
                >
                  移除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-form>
    </div>
    <template slot="footer">
      <el-button @click="cancel()">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import MultipleImageUpload from "@/components/MultipleImageUpload";
import SaveRule from "./form-rule";
import moment from "moment";
export default {
  mixins: [SaveRule],
  components: { MultipleImageUpload },
  data() {
    return {
      id: "",
      dataForm: {},
      visible: false,
      loading: false,
    };
  },
  watch: {
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    //读取加工单信息
    async getFactoryMakeInfo(id) {
      this.loading = true;
      try {
        const { data: res } = await this.$http.get(`/trade/factorymake/${id}`);
        this.loading = false;
        if(res.data.detailList&&res.data.detailList.length>0){
          res.data.detailList.forEach(item=>{
            item.realCount=''
          })
        }
        this.dataForm.sourceId = this.id;
        this.dataForm.storageId=res.data.storageId
        this.dataForm.detailList =res.data.detailList;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    delRow(index, row, dataKey) {
      if (this.dataForm[dataKey]) {
        this.dataForm[dataKey].splice(index, 1);
      }
    },
    async reset() {
      this.imgArr = [];
      this.dataForm = {
        id: "",
        remark: "",
        receiptCode:'',
        operateTime: moment().format("yyyy-MM-DD"),
        carriageNo: "",
        carriageMan: "",
        imgs: "",
        storageId: "",
        factoryName: "",
        sourceId: "",
        detailList: [
          {
            id: "",
            productId: "",
            count: "",
            remark: "",
            name: "",
            code: "",
            color: "",
            size: "",
            attr1: "",
            amount:'',
            realCount:''
          },
        ],
      };
    },
    async init() {
      this.reset();

      this.visible = true;
      if (this.id) {
        await this.getFactoryMakeInfo(this.id);
      }
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.clearValidate();
        }
      });
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          if (
            !this.dataForm.detailList ||
            this.dataForm.detailList.length === 0
          ) {
            return this.$message.error("明细不能为空");
          }
          let postForm = {
            receiptCode:this.dataForm.receiptCode,
            operateTime: this.dataForm.operateTime,
            carriageNo: this.dataForm.carriageNo,
            carriageMan: this.dataForm.carriageMan,
            purchaseAgreementId: this.dataForm.purchaseAgreementId,
            imgs: this.dataForm.imgs,
            remark: this.dataForm.remark,
            storageId: this.dataForm.storageId,
            sourceId:this.id,
            detailList: [],
          };
          this.dataForm.detailList.forEach((item) => {
            postForm.detailList.push({
              id: item.id,
              count: item.realCount,
              productId: item.productId,
              remark: item.remark,
            });
          });
          this.loading = true;
          this.$http
            .post("/trade/factorymake/check/in", postForm)
            .then(({ data: res }) => {
              this.loading = false;
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.cancel();
                  this.$emit("refreshDataList");
                },
              });
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
            });
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
